<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item>
      <el-checkbox
        v-model="filters.isSelect"
        key="checkbox"
        border
        :true-label="1"
        :false-label="0"
        @change="checkChange"
        >只看选中组织的管理员
      </el-checkbox>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.roleId"
        placeholder="角色"
      >
        <el-option
          v-for="(item, i) in roleData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="姓名/手机号"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getRoleList } from "@/api/role";
export default {
  components: { butn },
  // props: ['filters'],
  data() {
    return {
      filters: {
        isSelect: 0
      },
      options: [],
      roleData: [],
    };
  },
  created() {
    getRoleList().then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        uuid: "",
        roleName: "全部",
      });
      this.roleData = res.data.map((ele) => ({
        paramKey: ele.uuid,
        paramValue: ele.roleName,
      }));
    });
  },
  methods: {
    checkChange(val) {
      this.filters.isSelect = val;
      this.initData();
    },
    initData() {
      const params = { ...this.filters };
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {
        isSelect: 0
      };
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  // text-align: right;
  line-height: 40px;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
}
/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 8px;
}
</style>
